import "Decanter/js/core/core.js";
import "Decanter/js/components/components.js";

import "./user/comment_form.js";
import "../scss/user.scss";
